import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Config } from "@config/api.config";
import { HttpClient, HttpParams } from "@angular/common/http";
import { PagedResponse } from "@app/models/paged-response";

@Injectable({
  providedIn: "root",
})
export class TasksService {
  constructor(private http: HttpClient) {}

  findAll(page: number, size: number, sort?: string, direction?: string): Observable<PagedResponse<any>> {
    let params = new HttpParams().set("page", page).set("size", size);

    if (sort) {
      params = params.set("sort", `${sort},${direction || "asc"}`);
    }

    return this.http.get<PagedResponse<any>>(`${Config.webApiUrl}/v1/task`, { params });
  }

  findAllByPersonId(userId: string): Observable<any[]> {
    let params = new HttpParams();
    params = params.set("userId", userId.toString());

    return this.http.get<any[]>(`${Config.webApiUrl}/v1/task/person`, { params });
  }

  findById(id: string): Observable<any> {
    return this.http.get<any>(`${Config.webApiUrl}/v1/task/${id}`);
  }

  create(task: any): Observable<void> {
    return this.http.post<void>(`${Config.webApiUrl}/v1/task`, task);
  }

  update(id: string, task: any): Observable<void> {
    return this.http.put<void>(`${Config.webApiUrl}/v1/task/${id}`, task);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${Config.webApiUrl}/v1/task/${id}`);
  }
}
